import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faCalendarPlus, faEnvelope, faPhone, faGlobe, faScaleBalanced, faArrowRight, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'

import { lP, oP, sT, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, capFirstChar, sortEventsByDateStartDesc } from '../../../main.js'

import '../../../main.css'
import './ManageOrganization.css'
import './MManageOrganization.css'

import Cookies from 'universal-cookie'

export default function ManageOrganization() {

    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var [orgEventData, setOrgEventData] = useState([])
    var [loadedOrgEventData, setLoadedOrgEventData] = useState(0)

    var [orgData, setOrgData] = useState([])
    var [loadedOrgData, setLoadedOrgData] = useState(0)

    const { orgid } = useParams();

    useEffect(() => {
        getOrgData()
        getOrgEvents()
    }, [])

    function getOrgData() {
        try {
            setLoadedOrgData(0)
            fetch(URL_MAINAPI + "/organization/" + orgid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setOrgData(res.data)
                    setLoadedOrgData(1)
                } else {
                    setOrgData([])
                    setLoadedOrgData(0)
                }
            }))
        } catch (err) {
            setOrgData([])
            setLoadedOrgData(0)
        }
    }

    function getOrgEvents() {
        try {
            setLoadedOrgEventData(0)
            fetch(URL_MAINAPI + "/organization/orgevents/" + orgid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setOrgEventData(sortEventsByDateStartDesc(res.data))
                    setLoadedOrgEventData(1)
                } else {
                    setOrgEventData([])
                    setLoadedOrgEventData(0)
                }
            }))
        } catch (err) {
            setOrgEventData([])
            setLoadedOrgEventData(0)
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Organisationsverwaltung</title>
                <meta property="og:title" content="Organisationsverwaltung" />
                <meta property="og:description" content="Verwalte deine Organisation" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                {/* Breadcrumb */}
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>{loadedOrgData ? orgData.name : 'Organisation'}</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                >
                    {loadedOrgData ? orgData.name : <Skeleton height={30} width="60%" />}
                </motion.h1>

                {/* Org-Info-Karte */}
                <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                    <div className='card' style={{ padding: '26px 24px', marginTop: '20px', maxWidth: '680px' }}>
                        {(!loadedOrgData) ? <Skeleton width="100%" height={90} /> : (
                            <div>
                                {orgData.description ? (
                                    <p className="org-description">{orgData.description}</p>
                                ) : null}
                                <div className="kv-list">
                                    {orgData.contact && orgData.contact.email ? (
                                        <div className="kv"><FontAwesomeIcon icon={faEnvelope} /><b>E-Mail</b> {orgData.contact.email}</div>
                                    ) : null}
                                    {orgData.contact && orgData.contact.tel ? (
                                        <div className="kv"><FontAwesomeIcon icon={faPhone} /><b>Tel</b> {orgData.contact.tel}</div>
                                    ) : null}
                                    {orgData.contact && orgData.contact.url ? (
                                        <div className="kv"><FontAwesomeIcon icon={faGlobe} /><b>Web</b> {orgData.contact.url}</div>
                                    ) : null}
                                    {orgData.contact && orgData.contact.imprint_url ? (
                                        <div className="kv"><FontAwesomeIcon icon={faScaleBalanced} /><b>Impressum</b> {orgData.contact.imprint_url}</div>
                                    ) : null}
                                </div>
                            </div>
                        )}
                        <div style={{ marginTop: '18px' }}>
                            <CTAButton
                                variant="secondary"
                                title="Organisation bearbeiten"
                                onclick={() => lP('/manage/org/' + orgid + '/edit')}
                            />
                        </div>
                    </div>
                </motion.div>

                {/* Events der Organisation */}
                <div className='section-gap'>
                    <h2 style={{ fontSize: '24px' }}>Events der Organisation</h2>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '15px' }}>Hier findest du Events, die von dieser Organisation veranstaltet werden.</p>

                    {(loadedOrgData && orgData._id) ? (
                        <div style={{ marginTop: '14px', marginBottom: '14px' }}>
                            <CTAButton
                                variant="secondary"
                                title="Event erstellen"
                                onclick={() => lP('/manage/event/edit?orgid=' + orgData._id)}
                            />
                        </div>
                    ) : null}

                    {(!loadedOrgEventData) ? <Skeleton variant="grid" cols={3} count={3} /> : null}

                    <div className='grid grid-3' style={{ marginTop: '14px' }}>
                        {orgEventData.map(function (event) {
                            return (
                                <div
                                    key={event._id}
                                    className="card card-hover event-mini noselect"
                                    onClick={() => lP('/manage/event/' + event._id)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => { if (e.key === 'Enter') lP('/manage/event/' + event._id) }}
                                >
                                    <div className='event-mini-top'>
                                        <h3>{event.name}</h3>
                                        {(event.active != 1) ? (
                                            <span className='badge badge-error'><FontAwesomeIcon icon={faTriangleExclamation} /> inaktiv</span>
                                        ) : (
                                            <span className='badge badge-open'>aktiv</span>
                                        )}
                                    </div>
                                    <a href={'/manage/event/' + event._id} className='btn btn-primary btn-sm'>
                                        Verwalten <FontAwesomeIcon icon={faArrowRight} />
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
